<ng-container *ngIf="overallProgress$ | async as progress">
  <div class="job-status p-3" *ngIf="progress.totalJobs > 0">
    <a href="javascript:;" (click)="viewDetails()">
      <h6>{{
        progress.activeJobs > 0
          ? progress.activeJobs + ' Active Job(s)'
          : 'No Active Jobs'
      }}</h6>
      <mat-progress-bar
        color="accent"
        mode="determinate"
        [value]="progress.overallProgress"
      ></mat-progress-bar>
    </a>
  </div>
</ng-container>
